const buildPages = (variables, numberOfPages) => {
	// Assign the variables for each page
	let splittedVariables = [];
	for (let i = 0; i < numberOfPages; i++) splittedVariables.push([]);
	for (let i = 0; i < variables.length; i++) splittedVariables[Math.floor(i / 6)].push(variables[i]);

	// Converts variables to JSX elements
	let splittedComponents = splittedVariables.slice();
	for (let i = 0; i < numberOfPages; i++) {
		for (let j = 0; j < splittedVariables[i].length; j++) {
			splittedComponents[i][j] = (
				<div>
					<p>{splittedVariables[i][j].name}</p>
					<p>{splittedVariables[i][j].value}</p>
				</div>
			);
		}
	}

	return splittedComponents;
};

export default buildPages;
